<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  beforeDestroy() {
    localStorage.clear();
    sessionStorage.clear();
  },
};
</script>

<style lang="less">
.size {
  width: 100%;
  height: 100%;
}

html,
body {
  .size;
  overflow: hidden;
  margin: 0;
  padding: 0;
}

#app {
  .size;
}

.ivu-table-fixed {
  margin-bottom: 10px !important;
  background-color: #fff;
}

.ivu-table-fixed {
  pointer-events: none;
}

.ivu-table-fixed-header {
  pointer-events: all;
}

.ivu-table-fixed-body {
  pointer-events: all;
}
img {
  max-width: 100%;
  object-fit: cover;
}
body > div.el-popper.el-cascader__dropdown {
  z-index: 9999 !important;
}
</style>
